import * as sanitizeHtml from 'sanitize-html';

export function sanitiseHtml(html: string): string {
    return sanitizeHtml(html, {
        allowedTags: [],
    });
}